/**
 * 基础组件可直接使用时可以调用 getBasicComponent(compId) 获取组件，
 * 需要增加行为（比如埋点）时自行 import 具体基础组件进行包装
 */
const componentLib = {
  2001: () => import('@/components/templates/common/PinnedAwardsBtn'),
  2002: () => import('@/components/templates/common/PinnedRuleBtn'),
  2003: () => import('@/components/templates/common/PrimaryBtn'),
  2004: () => import('@/components/templates/common/FooterBtn'),
  2005: () => import('@/components/templates/common/FloatBtn'),
  2006: () => import('@/components/templates/common/Image'),
  2007: () => import('@/components/templates/common/PureActivityBoard'),
  2008: () => import('@/components/templates/common/GhostRuleBtn'),
  2009: () => import('@/components/templates/common/GhostAwardsBtn'),
  2010: () => import('@/components/templates/common/Broadcast')
};

export function getBasicComponent(compId) {
  if (!componentLib[compId]) {
    throw new Error(`组件不支持：${compId}`);
  }
  return componentLib[compId];
}
